import React from "react";
import styled from "styled-components";
import dashboard from "../assets/dashboard.png";
import { BsCheckLg } from "react-icons/bs";

const Modules = () => {
  return (
    <ModuleMain>
      <ModuleContainer>
        <div>
          <div className="border"></div>
          <h4>Advanced Modules</h4>
        </div>
        <h3>Easy way to track all your business</h3>
        <p>
          Being able to monitor everything what is going on in your buisness is
          crucial. Thousands of Shopify Brands have made the switch. Text
          marketing with customer in mind!
        </p>
      </ModuleContainer>
      <ModuleData>
        <ModuleGrid>
          <ModuleCard>
            <img src={dashboard} alt="" />
          </ModuleCard>
          <ModuleCard>
            <h3>Advanced Modules Provided</h3>
            <ul>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Manage Complete Business Accounting
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Compare Bank Statement
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Manage Sales
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Manage Expenses - category or Items wise
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Product Stock Management
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Profit & Loss Analysis
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Make Quotations
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Create GST Tax Invoice
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Create Purchase Orders
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Manage Purchase Bills
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Create Work Order
              </li>
              <li>
                <div>
                  <BsCheckLg className="check" />
                </div>
                Bank & Money
              </li>
            </ul>
          </ModuleCard>
        </ModuleGrid>
      </ModuleData>
    </ModuleMain>
  );
};

export default Modules;

const ModuleMain = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 4rem calc((100vw - 1000px) / 2);

  @media only screen and (max-width: 991px) {
    padding: 2rem calc((100vw - 1000px) / 2);
  }
`;

const ModuleContainer = styled.div`
  margin-bottom: 2.5rem;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0px;
    .border {
      background-color: #3aaa35;
      height: 3px;
      width: 45px;
    }
    h4 {
      text-transform: uppercase;
      font-weight: 500;
      font-size: 18px;
      margin-left: 15px;
      color: #3aaa35;
    }
  }
  h3 {
    font-size: 47px;
    font-weight: 600;
    color: #20204f;
    line-height: 65px;
    margin-top: 5px;
    text-align: center;
  }
  p {
    margin: auto;
    margin-top: 5px;
    font-weight: 500;
    color: #535353;
    width: 60%;
    text-align: center;
  }

  @media only screen and (max-width: 991px) {
    margin: 0px 15px;
    h3 {
      font-size: 35px;
      font-weight: 600;
      color: #20204f;
      line-height: 40px;
      margin-bottom: 0.9rem;
    }
    p {
      width: 97%;
    }
  }
`;

const ModuleData = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModuleGrid = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 2.5fr;
  grid-gap: 2rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    margin: 0px 10px;
  }
`;

const ModuleCard = styled.div`
  img {
    width: 500px;
    height: 450px;
  }
  h3 {
    text-align: left;
    font-size: 27px;
    font-weight: 600;
    color: #20204f;
  }
  ul {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    margin-top: 20px;
    list-style: none;
    li {
      color: #20204f;
      margin-right: 10px;
      margin-bottom: 1rem;
      font-size: 19px;
      display: flex;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #cfd3ff;
        border: 2px solid #20204f;
        height: 25px;
        width: 25px;
        border-radius: 50%;
        margin-right: 7px;

        .check {
          font-size: 16px;
          color: #20204f;
        }
      }
    }
  }
  @media only screen and (max-width: 991px) {
    img {
      width: 100%;
      height: 100%;
    }
    ul {
      li {
        font-size: 15px;
      }
    }
  }
`;
